export default {
  name: 'Mobile',

  computed: {
    userAgent() {
      return window.navigator.userAgent;
    },

    isMobile() {
      return this.isIOS || this.isAndroid;
    },

    isRN() {
      const userAgent = window.navigator.userAgent;

      if (userAgent.match(/classting_rn/i)) {
        return true;
      }
      return false;
    },

    isIOS() {
      const userAgent = window.navigator.userAgent;

      if (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i) || userAgent.match(/iPod/i)) {
        return true;
      }
      return false;
    },

    isAndroid() {
      const userAgent = window.navigator.userAgent;

      if (userAgent.match(/android/i)) {
        return true;
      }
      return false;
    },

    getAndroidVersion() {
      const userAgent = window.navigator.userAgent;
      const regex = /android\s([0-9]*)/;
      const match = regex.exec(userAgent.toLowerCase());

      if (match) {
        return match[1];
      }

      return 0;
    },

    isOldAndroid() {
      if (this.isAndroid && this.versionCompare(this.getAndroidVersion, '5.0.0') < 0) {
        return true;
      }

      return false;
    },

    isClasstingAndroid() {
      const userAgent = window.navigator.userAgent;
      const regex = /classting_android/i;
      const match = regex.exec(userAgent.toLowerCase());

      if (match) {
        return true;
      }

      return false;
    },

    getClasstingAndroidVersion() {
      const userAgent = window.navigator.userAgent;
      const regex = /classting_android[,\s]+([0-9]).([0-9]).([0-9])*/;
      const match = regex.exec(userAgent.toLowerCase());

      if (match) {
        const currentVersion = Number(match.slice(1, 4).join(''));
        return currentVersion;
      }

      return 0;
    },

    isClasstingIos() {
      const userAgent = window.navigator.userAgent;
      const regex = /classting_iphone/i;
      const match = regex.exec(userAgent.toLowerCase());

      if (match) {
        return true;
      }

      return false;
    },

    isClasstingClient() {
      return this.isClasstingAndroid || this.isClasstingIos;
    },

  },

  methods: {
    call(url) {
      if (this.isClasstingAndroid) {
        window.ctandroid.submitFromWeb(url);
      } else {
        window.location = url;
      }
    },

    versionCompare(left, right) {
      if (!(typeof left === 'string' && typeof right === 'string')) {
        return false;
      }

      const a = left.split('.');
      const b = right.split('.');
      const len = Math.max(a.length, b.length);

      for (let i = 0; i < len; i += 1) {
        if ((a[i] && !b[i] && parseInt(a[i], 10) > 0) ||
          (parseInt(a[i], 10) > parseInt(b[i], 10))) {
          return 1;
        } else if ((b[i] && !a[i] && parseInt(b[i], 10) > 0) ||
          (parseInt(a[i], 10) < parseInt(b[i], 10))) {
          return -1;
        }
      }

      return 0;
    },

    callActionbar(isVisible) {
      return this.call(`ctjscall://navigation?source=classting&is_visible=${isVisible}`);
    },

    openWebview(url) {
      return this.call(`ctjscall://open?source=classting&url=${encodeURIComponent(url)}`);
    },

    closeWebview() {
      return this.call('ctjscall://close?source=classting');
    },

    openSubscriptions() {
      return this.call('classting://prime/landing?source=classting');
    },

    refreshCoreConceptScore() {
      return this.call('ctjscall://refresh_score');
    },

    getDeviceName() {
      const userAgent = window.navigator.userAgent;

      if (
        userAgent.match(/iPad/i)
        || userAgent.match(/iPhone/i)
        || userAgent.match(/iPod/i)
      ) {
        return 'ios.event';
      }

      if (userAgent.match(/android/i)) {
        return 'android.event';
      }

      return 'web.event';
    },
  },
};
